export const contentApplications = `
    <div v-if="currentTab == idTab" :class="activeClass" data-tag-trigger="click" :data-tag-meta="taggingMeta">
        <slot></slot>
    </div>
`;
